export default __webpack_public_path__ + "static/media/ic_notes.9427dbc5.svg";